import { motion } from "framer-motion";
import styles from "../styles/index";
import { fadeIn, staggerContainer } from "../utils/motion";
import { useTranslation } from "react-i18next";
import { TypingText } from "../components/customText";
import arrowDown from "../public/arrow-down.svg";

const About = () => {
  const { t } = useTranslation();
  return (
    <section className={`${styles.paddings} relative z-10`}>
      <div className="gradient-02 z-0" />
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: "true", amount: 0.25 }}
      >
        <TypingText title={` ${t("about")}`} textStyles="text-center" />
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className={`${styles.about} dark:text-[#c7c7c7]`}
        >
          <span className="font-extrabold dark:text-white text-Darktext">{t("header1a")}</span>
          {t("aboutIran")}
        </motion.p>
        <div className="flex justify-center">
          <motion.img
            variants={fadeIn("up", "tween", 0.3, 1)}
            src={arrowDown}
            alt="arrow down"
            className="w-[18px] h-[28px] object-contain mt-[28px] self-center"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default About;
